import { EntityLinks } from '@griply/types';

// For a surface with no relationship documents to read: a goal template's preview, whose goals
// do not exist yet. Every goal then resolves through the legacy `ancestorIds` chain.
export const NO_ENTITY_LINKS: EntityLinks = { outgoing: {}, incoming: {} };
